import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=c80d9bde"
import script from "./pageTitle.ts?vue&type=script&lang=ts&external"
export * from "./pageTitle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports